import PayWithCreditCard from "./PayWithCreditCard";

export default PayWithCreditCard;